import _ from 'lodash';
import vehicleService from '@/services/vehicleService';

const getEngineAV = function({ state, rootState }) {
  // return object with real AV;
  // often in the equipment values array, engine has the collectAv instead of real AV, which makes creating offer difficult;
  let parameters;
  let avObject;
  parameters = {
    fiCode: rootState.vehicleIdentification.vehicleType.fiCode,
    constructionTime: rootState.vehicleIdentification.vehicleType.constructionTime.valueOf(),
    serviceIds: rootState.vehicleServices.selectedServices.map(s => s.id),
    fuelIds: state.selectedEquipments.find((e) => e.externalId.includes('FUEL_ID')).externalId,
    avGroups: 'ENGINE'
  };
  return vehicleService.getAvsByService(parameters)
    .then(res => {
      // first check if there are any engine options for the vehicle
      let avmo = state.selectedEquipments.find((e) => e.externalId.includes('AVMO')).externalId.split('-')[3]; // original ecode AV
      if (res.data.options) {
        // if there are options, iterate through the options array and choose the item where av or collectAv property
        // equals the original AV from ecode endpoint
        // also huaRelevant must equal true
        let avsObjectArray = res.data.options[0].selections[0].avs.filter(item => item.huaRelevant); // array of av options
        let avParentObj = avsObjectArray.find((e) => (e.av && e.av.av && e.av.av.includes(avmo)) ||
          (e.av && e.av.collectAv && e.av.collectAv.includes(avmo)));
        avObject = avParentObj && avParentObj.av; // av object to return
      } else if (res.data.mandatoryAvs) {
        // or if there is mandatory av array, take the object from there
        avObject = res.data.mandatoryAvs.find((e) => (e.av && e.av.includes(avmo)) || (e.collectAv && e.collectAv.includes(avmo))); // av object to return
      }
      if (avObject) { // return the object if found
        return Promise.resolve(avObject);
      }
      // if no objects meets the required conditions or there are no engine options
      return getAvIfNoOptions();
    });

  function getAvIfNoOptions() {
    parameters = vehicleService.decodeFicode(rootState.vehicleIdentification.vehicleType.fiCode);
    _.extend(parameters, {
      fuelId: state.selectedEquipments.find((e) => e.externalId.includes('FUEL_ID')).externalId,
      collectAv: state.selectedEquipments.find((e) => e.externalId.includes('AVMO')).externalId.split('-')[3],
      constructionTime: rootState.vehicleIdentification.vehicleType.constructionTime.valueOf()
    });
    return vehicleService.getAvs(parameters) // get av with collectAV param
      .then(res => {
        if (res.data.length > 0) {
          // if there are items, then the AV was collectAV
          // just return the first item
          return Promise.resolve(res.data[0]);
        } else {
          // if there are no items returned, the AV was real AV and we can just return the object from the same endpoint,
          // just with av param instead of collectAV
          parameters = vehicleService.decodeFicode(rootState.vehicleIdentification.vehicleType.fiCode);
          _.extend(parameters, {
            fuelId: state.selectedEquipments.find((e) => e.externalId.includes('FUEL_ID')).externalId,
            avs: state.selectedEquipments.find((e) => e.externalId.includes('AVMO')).externalId.split('-')[3],
            constructionTime: rootState.vehicleIdentification.vehicleType.constructionTime.valueOf()
          });
          return vehicleService.getAvs(parameters)
            .then((res) => res.data[0]);
        }
      });
  }
};

const setDefaultAvEquipments = function({ commit }, equipment) {
  return commit('SET_DEFAULT_AV_EQUIPMENTS', equipment);
};

const getAvsByService = ({ commit, state, rootState }, selectedAvIds) => {
  let params = {
    selectedAvIds: selectedAvIds,
    serviceIds: rootState.vehicleServices.selectedServices.map(service => service.id),
    fiCode: rootState.vehicleIdentification.vehicleType.fiCode,
    constructionTime: rootState.vehicleIdentification.vehicleType.constructionTime.valueOf(),
    fuelIds: state.selectedEquipments.find((e) => e.externalId.includes('FUEL_ID')).externalId
  };
  return vehicleService.getAvsByService(params)
    .then((res) => {
      const optionLength = res.data.options && res.data.options.length;
      if (optionLength) {
        res.data.options[0].show = true;
        res.data.options[optionLength - 1].last = true;
      }
      commit('SET_AVS', res.data);
      return res;
    });
};

const skipEquipmentSelection = function({ commit }, flag) {
  return commit('SET_SKIP_EQUIPMENT_SELECTION', flag);
};

const setVehicleEquipmentList = ({ commit }, list) => {
  commit('SET_VEHICLE_EQUIPMENT_LIST', list);
};

const setTemporaryEquipmentAvs = function({ commit }, option) {
  commit('SET_TEMPORARY_EQUIPMENT_AVS', option);
};

const getAvsByGroup = ({ commit, state, rootState }, params) => {
  params.serviceIds = rootState.vehicleServices.selectedServices.map(service => service.id);
  params.fiCode = rootState.vehicleIdentification.vehicleType.fiCode;
  params.constructionTime = rootState.vehicleIdentification.vehicleType.constructionTime.valueOf();
  params.fuelIds = state.selectedEquipments.find((e) => e.externalId.includes('FUEL_ID')).externalId;
  return vehicleService.getAvsByService(params);
};

const updateAvsGroup = ({ commit }, avGroup) => {
  commit('UPDATE_AVS_GROUP', avGroup);
};

const hideAvGroupsIfDisplayed = ({ commit }, avGroup) => {
  commit('HIDE_AV_GROUPS', avGroup);
};

export default {
  getEngineAV,
  setDefaultAvEquipments,
  getAvsByService,
  skipEquipmentSelection,
  setVehicleEquipmentList,
  setTemporaryEquipmentAvs,
  getAvsByGroup,
  updateAvsGroup,
  hideAvGroupsIfDisplayed
}
